import { RegistrationType } from '@/@types/generated/models/RegistrationType'
import { register } from './enum'

const RegistrationTypeLabels: Record<RegistrationType, string> = {
  [RegistrationType.MOTOR_CARRIER]: 'Motor Carrier',
  [RegistrationType.BROKER]: 'Broker Only (not a motor carrier)',
  [RegistrationType.INSURANCE_PROVIDER]: 'Insurance Provider',
}

register<RegistrationType>(RegistrationType, (v) => {
  if (!v) return '\u2014'
  return RegistrationTypeLabels[v]
})
